import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
  const userString = localStorage.getItem('user');
  const user = userString ? JSON.parse(userString) : {};
  const role = user.role || 'STANDARD';
  const isAdmin = role === 'ADMIN';

  const adminFeatures = [
    {
      id: 1,
      title: 'Setup Agent',
      description: 'Create and configure Amazon Connect agents individually or in bulk using CSV files',
      icon: '\uD83D\uDC64',
      path: '/setup-agent',
      color: '#4caf50'
    },
    {
      id: 2,
      title: 'Setup Queue',
      description: 'Create and configure Amazon Connect queues individually or in bulk using CSV files',
      icon: '\uD83D\uDCCB',
      path: '/setup-queue',
      color: '#2196f3'
    },
    {
      id: 6,
      title: 'Bulk Job History',
      description: 'View the status and results of all bulk agent upload jobs you have submitted',
      icon: '\uD83D\uDCCB',
      path: '/bulk-jobs',
      color: '#009688'
    },
    {
      id: 7,
      title: 'Setup Colleague Data',
      description: 'Upload a JSON file to add or update records in the program data table',
      icon: '\uD83D\uDDC4\uFE0F',
      path: '/setup-program-data',
      color: '#673ab7'
    },
    {
      id: 8,
      title: 'Setup Quick Connect',
      description: 'Create Amazon Connect quick connects from JSON files (single or bulk)',
      icon: '\u26A1',
      path: '/setup-quick-connect',
      color: '#00897b'
    },
    {
      id: 9,
      title: 'Setup Routing Profile',
      description: 'Create Amazon Connect routing profiles from JSON files (single or bulk)',
      icon: '\uD83E\uDDED',
      path: '/setup-routing-profile',
      color: '#1976d2'
    },
    {
      id: 10,
      title: 'Setup Security Profile',
      description: 'Create Amazon Connect security profiles from JSON files (single or bulk)',
      icon: '\uD83D\uDEE1\uFE0F',
      path: '/setup-security-profile',
      color: '#7b1fa2'
    },
    {
      id: 11,
      title: 'Setup User Hierarchy Group',
      description: 'Create Amazon Connect user hierarchy groups from JSON files (single or bulk)',
      icon: '\uD83C\uDFD7\uFE0F',
      path: '/setup-user-hierarchy-group',
      color: '#5d4037'
    },
    {
      id: 12,
      title: 'Setup Send Notification',
      description: 'Upload JSON to send notifications for a selected Amazon Connect instance',
      icon: '\uD83D\uDD14',
      path: '/setup-send-notification',
      color: '#d32f2f'
    },
    {
      id: 3,
      title: 'View Agents',
      description: 'View and search existing Amazon Connect agent configurations',
      icon: '\uD83D\uDD0D',
      path: '/view-agents',
      color: '#ff9800',
      comingSoon: true
    },
    {
      id: 4,
      title: 'Reports',
      description: 'Generate and download reports on agent activity and configurations',
      icon: '\uD83D\uDCCA',
      path: '/reports',
      color: '#9c27b0',
      comingSoon: true
    },
    {
      id: 5,
      title: 'Settings',
      description: 'Manage application settings and user preferences',
      icon: '\u2699\uFE0F',
      path: '/settings',
      color: '#607d8b',
      comingSoon: true
    }
  ];

  const standardFeatures = [
    {
      id: 3,
      title: 'View Agents',
      description: 'View and search existing Amazon Connect agent configurations',
      icon: '\uD83D\uDD0D',
      path: '/view-agents',
      color: '#ff9800',
      comingSoon: true
    },
    {
      id: 4,
      title: 'Reports',
      description: 'View reports on agent activity and configurations',
      icon: '\uD83D\uDCCA',
      path: '/reports',
      color: '#9c27b0',
      comingSoon: true
    }
  ];

  const features = isAdmin ? adminFeatures : standardFeatures;

  return (
    <div className="home-page">
      <div className="home-header">
        <h1>Welcome, {user.name || user.lan_id || 'User'}</h1>
        <p className="home-subtitle">
          {isAdmin
            ? 'You have administrator access to manage Amazon Connect resources'
            : 'You have standard access to view Amazon Connect resources'}
        </p>
        <div className="home-role-indicator">
          <span className={'home-role-badge ' + (isAdmin ? 'home-role-admin' : 'home-role-standard')}>
            {isAdmin ? 'Administrator' : 'Standard User'}
          </span>
        </div>
      </div>

      <div className="features-grid">
        {features.map((feature) => {
          if (feature.comingSoon) {
            return (
              <div
                key={feature.id}
                className="feature-card feature-card-disabled"
                style={{ '--feature-color': feature.color }}
              >
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                <span className="coming-soon-badge">Coming Soon</span>
              </div>
            );
          }
          return (
            <Link
              key={feature.id}
              to={feature.path}
              className="feature-card"
              style={{ '--feature-color': feature.color }}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
              <span className="feature-arrow">&rarr;</span>
            </Link>
          );
        })}
      </div>

      <div className="home-info">
        <h2>User Profile</h2>
        <div className="info-grid">
          <div className="info-card">
            <h3>Name</h3>
            <p>{user.name || 'N/A'}</p>
          </div>
          <div className="info-card">
            <h3>Email</h3>
            <p>{user.email || 'N/A'}</p>
          </div>
          <div className="info-card">
            <h3>LAN ID</h3>
            <p>{user.lan_id || 'N/A'}</p>
          </div>
          <div className="info-card">
            <h3>Role</h3>
            <p>{role}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;